// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mainNavigationStyles } from "@stoneage/Overrides/Widgets/Header/MainNavigation";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";
import { color } from "@stoneage/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { IconWrapper } from "@insite/mobius/Icon";
import IconArrowDownLightSmall from "@stoneage/XDL/Icons/IconArrowDownLightSmall";

mainNavigationStyles.container = {
    css: css`
        display: flex;
        justify-content: left;
        align-items: center;
    `,
};

mainNavigationStyles.itemWrapper = {
    css: css`
        display: flex;
        align-items: stretch;
    `,
};

mainNavigationStyles.menuItemTypography = {
    ...fontConfig.regularSingleLine,
    weight: fontConfig.weight.medium,
    color: "secondary",
    ellipsis: true,
};

mainNavigationStyles.menuItem = {
    css: css`
        &:focus {
            outline: none;
        }

        & > ${TypographyStyle} {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px 24px;
            height: 35px;
            text-transform: capitalize;

            & > ${IconWrapper} {
                color: ${color("common.ui6")};
            }
        }

        &[data-open],
        &:not([disabled]):hover {
            background-color: ${color("primary")};
            & > ${TypographyStyle} {
                color: ${color("common.white")};
                & > ${IconWrapper} {
                    color: ${color("common.white")};
                }
            }
        }

        &[data-open] {
            & > ${TypographyStyle} > ${IconWrapper} {
                transform: rotate(180deg);
            }
        }
    `,
};

mainNavigationStyles.menuItemIcon = {
    size: 12,
    src: IconArrowDownLightSmall,
    css: css`
        margin-right: 0;
    `,
};
